/* eslint-disable quotes */
// Common
import "../components/kw-banner/kw-banner.js";
import "../components/kw-button-languages/kw-button-languages.js";
import "../components/kw-card-item/kw-card-item.js";
import "../components/kw-footer/kw-footer.js";
import "../components/kw-header/kw-header.js";
import "../components/kw-section/kw-section.js";
import "../components/kw-title/kw-title.js";
// Load Web components
import "../components/kw-wrapper-cards/kw-wrapper-cards";
import dataBanners from "../json/bannerCathedraData.json";
import "./lib/common/common.js";
import DataLanguage from "./lib/data-language.js";
import dataBanner from "./lib/dataBanner.js";
// Load libraries
import "./lib/scroll/scroll.js";

const { lang } = document.querySelector("html");

function banner() {
  const bannerData = document.getElementById("banner-cathedra");
  bannerData.innerHTML = `
            <kw-banner id="Banner" banner-size="small-cathedra" animation-type="slide-toleft" change-interval="8" class="cathedra__kw-banner-clip-path">
                ${DataLanguage.dataLanguage(
    dataBanners.bannerCathedraData,
    lang,
  )
    .map(dataBanner.banner)
    .join("")}
            </kw-banner>
      `;
}
function hideCards() {
  if (window.innerWidth < 768) {
    document.getElementById("imagesBenefits").className = "benefits_hidden-container";
    // document.getElementById("imagesBenefits2").className = "benefits_hidden-container";
  }
}

/* eslint-disable-next-line */
window.onload = function () {
  banner();
  hideCards();
};
if (document.addEventListener) {
  window.addEventListener("load", window.onload);
}
